// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pictrue[data-v-e703c786] {\n  width: 60px;\n  height: 60px;\n  border: 1px dotted rgba(0, 0, 0, 0.1);\n  margin-right: 10px;\n  position: relative;\n  cursor: pointer;\n}\n.pictrue img[data-v-e703c786] {\n  width: 100%;\n  height: 100%;\n}\n.required-star[data-v-e703c786]  .el-form-item__label::before {\n  content: \"*\";\n  color: #F56C6C;\n  margin-right: 4px;\n}", ""]);
// Exports
module.exports = exports;
